<template>
	<ul class="InlineList" :class="classes">
		<!-- @slot CloInlineListItem goes here, and an anchor inside that -->
		<slot />
	</ul>
</template>

<script>
import CloInlineListItem from '@/base/CloInlineList/CloInlineListItem.vue';
export default {
	name: 'CloInlineList',
	components: {
		CloInlineListItem,
	},
	data() {
		return {};
	},
	props: {
		/**
		 * Separate items with vertical line
		 */
		divided: {
			type: Boolean,
			default: false,
		},
		/**
		 * For use on a dark background
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * DEPRECATED
		 */
		separated: {
			type: Boolean,
			default: false,
		},
		/**
		 * DEPRECATED
		 */
		wide: {
			type: Boolean,
			default: false,
		},
		/**
		 * DEPRECATED
		 */
		column: {
			type: Boolean,
			default: false,
		},
		/**
		 * DEPRECATED
		 */
		flex: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				'InlineList--reverse': this.reverse,
				'InlineList--divided': this.divided,
				'InlineList--wide': this.wide,
				'InlineList--column': this.column,
				'InlineList--flex': this.flex,
				'InlineList--breadcrumbs': this.separated,
			};
		},
	},
};
</script>

<style lang="scss">
/* =============================================================================
	InlineList
----------------------------------------------------------------------------- */

@mixin InlineList {
	margin-left: 0;
	[dir='rtl'] & {
		margin-left: auto;
		margin-right: 0;
	}
	list-style: none;
	&:last-child {
		margin-bottom: 0;
	}
	li {
		display: inline-block;
		//vertical-align: middle;
		padding-right: 0.4rem;
		margin-right: 0.2rem;
		[dir='rtl'] & {
			margin-left: 0.2rem;
			margin-right: auto;
		}
		&:last-child {
			padding-right: 0;
			margin-right: 0;
			[dir='rtl'] & {
				margin-left: 0;
			}
		}
	}
}

@mixin InlineList--reversed {
	color: $color-text-reverse;
	color: rgba(255, 255, 255, 0.7);
	a {
		color: $color-text-reverse;
		color: rgba(255, 255, 255, 0.7);
		&:hover {
			color: $color-text-reverse;
		}
	}
	&.InlineList--divided {
		li {
			border-color: $color-neutral-4;
			border-color: rgba(255, 255, 255, 0.1);
		}
	}
}

@mixin InlineList--divided {
	li {
		line-height: 1;
		border-right: 1px solid;
		[dir='rtl'] & {
			border-right: 0;
			border-left: 1px solid;
		}
		border-color: $color-neutral-1;
		border-color: rgba(0, 0, 0, 0.2);
		padding-right: 0.6rem;
		[dir='rtl'] & {
			padding-right: 0;
			padding-left: 0.6rem;
		}
		margin-right: 0.4rem;
		&:last-child {
			border-right: 0;
			[dir='rtl'] & {
				border-left: 0;
			}
		}
	}
}

@mixin InlineList--wide {
	li {
		padding-right: 1.4rem;
		margin-right: 1.4rem;
		[dir='rtl'] & {
			margin-left: 1.4rem;
			margin-right: auto;
		}
	}
}

.InlineList {
	@include InlineList;
}

.InlineList-active {
	a {
		font-weight: bold;
		color: $color-text;
		&:hover {
			cursor: default;
		}
	}
}

.InlineList--activeBackground {
	a {
		background-color: $color-neutral-1;
		padding: 0.3rem;
		&:hover {
			cursor: default;
		}
	}
}

// TODO: deprecate reversed
.InlineList--reverse,
.InlineList--reversed {
	@include InlineList--reversed;
}

.InlineList--divided {
	@include InlineList--divided;
}

.InlineList--wide {
	@include InlineList--wide;
}
// TODO: deprecate breadcrumbs
.InlineList--breadcrumbs {
	margin: 0.5rem 0;
	li {
		padding-right: 0.1rem;
		margin-right: 0.1rem;
		[dir='rtl'] & {
			margin-left: 0;
			padding-left: 0;
			margin-right: 0.1rem;
			padding-left: 0.1rem;
		}
		a {
			font-weight: bold;
		}
	}
	.InlineList-divider {
		.Icon {
			@include icon-sm;
			padding-bottom: 1px;
			fill: $color-neutral-3;
		}
	}
}

.InlineList--inline {
	display: inline;
	margin-left: 0.25rem;
	[dir='rtl'] & {
		margin-left: auto;
		margin-right: 0.25rem;
	}
}

/* Column variant aligns items in columns
	for browsers that support grid */
.InlineList--column {
	display: flex;
	flex-wrap: wrap;
	li {
		margin: 0;
		@include inset-xs; // safe padding fallback
		flex: 1 1 12rem;
		line-height: 1.4;
		display: flex;
		> * {
			flex-grow: 1;
			@include inset-squish-sm;
			border-radius: 3px;
			background-color: $color-primary-1;
		}
	}
	/* For browsers that support grid */
	@supports (display: grid) {
		display: grid;
		grid-gap: $space-xs;
		grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
		li {
			padding: 0; // Unset padding, handled by grid gap
		}
	}
}

.InlineList--flex {
	display: inline-flex;
	flex-wrap: wrap;
	align-items: baseline;
	line-height: inherit;
	li:not(:last-child) {
		padding: 0;
		margin: 0 1em 0 0;
		[dir='rtl'] & {
			margin: 0 0 0 1em;
		}
	}
}
</style>
